import gql from 'graphql-tag';

export const GET_LIST_RECIPE_SEASON_MONTH = gql`
  fragment recipeSeasonMonthOne on recipe_season_month {
    id
    recipe_id
    season_month
  }
`;
